import React from "react";
import "./DropdownApp.scss";
import Dropdown from "../Dropdown";

const DropdownApp = (props) => {
  const handleClick = (e) => {
    if (!!props.buttonClicked) {
      props.buttonClicked(e);
    }
  };
  return (
    <Dropdown isExpanded={props.isExpanded}>
      <div className="app-group-content">
        {props.items.items.map((x, index) => {
          return (
            <button
              id={x.id}
              key={index}
              className="app-group-button"
              onClick={handleClick}
            >
              <i className={x.icon}></i>
              <div className="text">{x.label}</div>
            </button>
          );
        })}
      </div>
    </Dropdown>
  );
};

export default DropdownApp;
